import vue from '@/main';

const validationMessages = {
  required: vue.$gettext('This field is required.'),
  minValue: vue.$gettext('This value should greater or equal to %{ n }.'),
  datesRange: vue.$gettext('Start date should be earlier than the end date.'),
  requiredYearIfMonth: vue.$gettext('Year is required if month is filled.'),
  maxLength: vue.$gettext('The maximum length is %{n} characters'),
  isInteger: vue.$gettext('This value should be a positive integer'),
  email: vue.$gettext('Invalid email address.'),
  phone: vue.$gettext('Invalid phone number.')
};

export default {
  required(value) {
    return !value ? validationMessages.required : '';
  },
  minValue(min) {
    return value => (+value < +min ? vue.$gettextInterpolate(validationMessages.minValue, {n: min}) : '');
  },
  requiredYearIfMonth(value) {
    return !value ? validationMessages.requiredYearIfMonth : '';
  },
  isPositiveInteger(value) {
    const number = Number.parseInt(value);
    return number.toString() === value.toString() && number > 0 ? '' : validationMessages.isInteger;
  },
  email(value) {
    const emailPattern = /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~|.]+@[a-zA-Z0-9.]*[a-zA-Z0-9]$/;
    return emailPattern.test(value) ? '' : validationMessages.email;
  },
  phone(value) {
    /* eslint-disable */
    const phonePattern = /^[\+]?[0-9]{0,2}[-\s\.]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/;
    return phonePattern.test(value) ? '' : validationMessages.phone;
  },
  validateRangeDates(startMonth, startYear, endMonth, endYear) {
    if (startYear && endYear) {
      let startDate = new Date(startYear, startMonth || 1);
      let endDate = new Date(endYear, endMonth || 1);
      return startDate > endDate ? validationMessages.datesRange : '';
    }
    return '';
  },
  validateField(rules, value) {
    let messages = [];
    for (let rule of rules) {
      messages.push(rule(value));
    }
    return messages.filter(value => value).join('<br/>');
  },
  maxLength(max) {
    return value =>
      value && (value.length || 0) > +max ? vue.$gettextInterpolate(validationMessages.maxLength, {n: max}) : '';
  }
};
